import { hasBrowserWindowAccess, isDevEnv } from "@buildwithflux/shared";
import firebase from "firebase/compat/app";
import { set } from "lodash";
import "firebase/compat/analytics";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
export * as firebase from "firebase/compat/app";
export function getFirebaseCompatApp(firebaseAppConfig, firebaseAppName) {
    if (isDevEnv() && hasBrowserWindowAccess() && !globalThis.firebase) {
        set(globalThis, ["__FLUX__", "firebase"], firebase);
    }
    try {
        return firebase.app(firebaseAppName);
    }
    catch (error) {
        // Couldn't find safe access to FirebaseError, but that's the real type
        const code = error?.code;
        if (code?.endsWith("no-app")) {
            // app instance is not initialized, we can do that now
            return firebase.initializeApp(firebaseAppConfig, firebaseAppName);
        }
        else {
            throw error;
        }
    }
}
//# sourceMappingURL=app.js.map